import React, { useCallback } from 'react'

export const Switch = ({ id, label, onChange, checked }) => {
	// eslint-disable-next-line
	const handleChange = useCallback(ev => onChange(ev.target.checked), [])

	return (
		<div className="d-flex align-items-center">
			<span className="kt-switch">
				<label>
					<input checked={checked} id={id} onChange={handleChange} type="checkbox" />
					<span />
				</label>
			</span>
			<label className="ml-2 cur-p" htmlFor={id}>
				{label}
			</label>
		</div>
	)
}
